export const ROUTE_PREFIX = '/omni-search';

export const addRoutePrefix = (path: string): string => {
	return `${ROUTE_PREFIX}${path}`;
};
